import { isMinLength } from './common/validations';

let formSchema = {
	firstName: '',
	lastName: '',
	phoneNumber: '',
	emailAddress: '',
	howDidYouHearAboutMayple: '',

	websiteAddress: '',
	companyName: '',

	industry: [{
		industryCategory: 'STYLE_AND_FASHION',
		industrySubCategory: 'CLOTHING_AND_SHOES'
	}],

	locations: [
		'US'
	],

	productBusinessModel: [],

	estimatedMediaBudget: 0,
	frontendSalesQualificationScore: 0,

	genders: [],

	isECommerce: true,
	languages: [],

	launchTimeFramePreference: 'UP_TO_ONE_WEEK',
	mainGoal: 'IMPROVE_EXISTING_CAMPAIGNS',

	preferLocalMarketers: true,
	preferMarketerInTargetedLocations: false,

	requestsAssistanceForRequiredSkillsChoice: true,
	serviceTypes: [
		'GOOGLE_ADS',
		'FACEBOOK_ADS'
	],
	state: undefined,
	targetKPI: 'ROAS',
	targetKPIValue: 0,

	ages: [],

	trafficSource: 'brief-v5',
	lpTrafficSource: '',
	partnerStackReferralKey: '',
	requestedAnInstantCall: 'no',
}

const validationRules = {
	websiteStep: {
		dependencies: [],
		inputs: {
			websiteAddress: {
				validate: function(val) {
					let url;
					
					try {
						url = new URL(val);
					} catch (_) {
						return false;
					}
				
					if (!(url.protocol === "http:" || url.protocol === "https:")) {
						return false;
					}
				
					const hostnameRegex = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.([a-zA-Z0-9]|[a-zA-Z0-9-]*[a-zA-Z0-9])*\.?[a-zA-Z]{2,}$/;
					if (!hostnameRegex.test(url.hostname)) {
						return false;
					}
				
					return true;
				},
				errorLog: "Hmm, this doesn't look a valid website address."
			},
			companyName: {
				validate: function(val) {
					if (val.length < 2) {
						return false; }
					else { return true; }
				}
			}
		},
		eventReporting: function() {
			// const websiteTraits = {
			// 	label: (formSchema['websiteAddress'] || 'N/A').toString(), // Save as string
			// 	websiteAddress: formSchema['websiteAddress'], // Save as int
			// };

			briefHench.websiteSDK.reportEvent('Wizard.Brief.Website StepDone', {websiteAddress: formSchema.websiteAddress});
		}
	},
	meetingContainer: {
		dependencies: [],
		inputs: {},
		eventReporting: function() {
			briefHench.websiteSDK.reportEvent('Wizard.Brief.Call Skipped');
		}
	},
	// Inner Object Names (e.g. firstName) Must Match with the Input's "name" Attribute
	//
	briefForm: {
		dependencies: [],
		inputs: {
			firstName: {
				validate: function(val) {
					return isMinLength(val);
				},
				errorLog: 'Please fill the name field'
			},
			lastName: {
				validate: function(val) {
					return isMinLength(val);
				},
				errorLog: 'Please fill the lastname field'
			},
			// userTitle: {
			// 	validate: function(val) {
			// 		return isMinLength(val);
			// 	},
			// 	errorLog: 'Please fill the title field (Mr. | Mrs. | Ms.).'
			// },
			emailAddress: {
				validate: function(val) {
					return isMinLength(val) &&
								 String(val)
									 .toLowerCase()
									 .match(
										 /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
									 );
				},
				errorLog: 'Please fill the email address'
			},
			phoneNumber: {
				validate: function(val) {
					return briefHench.validatePhone(val);
				},
				errorLog: 'Please fill the phone number field'
			}
		},
		eventReporting: function() {
			const budgetTraits = {
				label: (formSchema['estimatedMediaBudget'] || 'N/A').toString(), // Save as string
				estimatedMediaBudget: formSchema['estimatedMediaBudget'], // Save as int
			};

			briefHench.websiteSDK.reportEvent('Wizard.Brief.LeadForm StepDone', budgetTraits);
		}
	}
}

let briefHench = {
	currentStep: 0,

	selectedSkills: [],

	ipLocation: 'US',

	fromTierICountry: true,

	hasSentAbandonEvent: false,

	hasSubmittedForm: false,
	
	validEmail: false,

	environment: 'torky',

	debug: '',

	leadToken: '',

	bannedURLs: [
		"idk",
		"mayple",
		"dontknow",
		"website",
		"unsure",
		"nothing",
		"tbd"
	],

	tierICountries: [ 'AU', 'AT', 'BA', 'CA', 'FI', 'FR', 'DE', 'ID', 'IL', 'NL', 'ZA', 'ES', 'TH', 'GB', 'US' ],

	checkTrafficSource: function(from) {
		const self = this;
		let fromLP = sessionStorage.getItem('callScheduled');

		if (fromLP || fromLP === 'true' || !self.fromTierICountry) {
			delete validationRules['meetingContainer'];
			$('.welcome-v5-step-1[welcome-v5-step="2"]').remove();
		}
	},

	loadSDK: function(src, callback) {
        var script = document.createElement('script');
        script.src = src;
        script.onload = callback;
        script.onerror = function() {
            console.error('Failed to load script: ' + src);
        };
        document.head.appendChild(script);
    },

	insertSDK: function() {
		const self = this;
		const WebsiteSDK = window.WebsiteSDK.default;
		self.websiteSDK = new WebsiteSDK({environment: self.environment});
	},

	handleStepChange: function() {
		const self = this;

		const nextButton = $('.next-step-button');
		const backButton = $('.previous-step-button');

		nextButton.click(function(e) {
			self.toNextStep();
		});
		backButton.click(function(e) {
			self.toPreviousStep();
		});
	},

	toNextStep: function() {
		const self = this;

		// $('.brief-next-button').addClass('disabled');

		let currentContainer = $('.welcome-step.active form').attr('data-name');

		// Run validations for each of the fields inside the current container
		//
		let isValid = self.checkErrors(currentContainer);

		if(!isValid) {
			console.warn( 'There is an issue' );
			$('.w-form-fail').css('display', 'block');
			$('.brief-next-button').addClass('disabled');
			return;
		}

		// If the validation passes;
		// reveal buttons
		$('.welcome-step.active .brief-next-button').addClass('disabled');
		$('.w-form-fail').css('display', 'none');

		// get current step index
		let currentStep = $('.welcome-step.active').index();

		// entail tracking for step changes
		window.entailInsights.trackEvent('button-click', { text: $('.welcome-step.active .next-step-button .button-text').text() });

		// If it's the last step,
		// submit the form to Hubspot
		if (currentStep ===  $('.welcome-step').length - 1) {
			self.toggleSubmitButtonVisibility();
			self.submitForm();
			// // self.createLead();

			return;
		}

		currentStep++;
		self.currentStep = currentStep;

		$(window).scrollTop(0);

		//$(`.brief-next-button[data-step="${currentStep}"`).removeClass('hidden');

		if (currentStep ===  $('.welcome-step').length - 1) {
			$('.brief-next-button').addClass('submittable');
		}

		$('.welcome-step').removeClass('active').addClass('hidden');
		$('.welcome-step').eq(currentStep).addClass('active').removeClass('hidden');

		$('.filled-block').attr('data-step', currentStep);

		let nextContainer = $('.welcome-step.active form').attr('data-name');

		// Get scripts/external libraries for the next step
		//
		// self.setDependencies(nextContainer);

		// Send reporting for the current/finished step
		//
		validationRules[currentContainer].eventReporting();
	},

	toPreviousStep: function() {
		const self = this;

		// $('.brief-next-button').addClass('disabled');

		let currentContainer = $('.welcome-step.active form').attr('data-name');

		let currentStep = $('.welcome-step.active').index();

		currentStep--;
		self.currentStep = currentStep;

		$('.brief-form-v2').removeClass('active');
		$('.brief-form-v2').eq(currentStep).addClass('active');

		$('.welcome-step').removeClass('active').addClass('hidden');
		$('.welcome-step').eq(currentStep).addClass('active').removeClass('hidden');

		$('.filled-block').attr('data-step', currentStep);
	},

	createLead: async function() {
		const self = this;

		let cPanelFormSubmitFailed = false;

		// Try/catch block of
		// Project Lead Creation
		//
		try {
			const result = await self.websiteSDK.createProjectLeadWithToken(formSchema);

			self.leadToken = result;

			console.log('Lead creation r: ', result);

			self.leadToken.length < 1 ? cPanelFormSubmitFailed = true : cPanelFormSubmitFailed = false;
		} catch (error) {
			cPanelFormSubmitFailed = true;

			console.error(error);

			self.showErrorMessage();
			self.toggleSubmitButtonVisibility();

			throw new Error("error on Project Lead Creation", { cause: error });
		}

		if (!cPanelFormSubmitFailed) {
			console.log('Lead submitted');
			// ttq.track('CompletePayment');

			self.websiteSDK.reportEvent('Wizard.Brief Finished', { category: 'Wizard.Brief', action: 'Finished' });
			self.websiteSDK.reportEvent('Lead Created', { category: 'Lead', action: 'Created' });

			const redirectionURL = self.websiteSDK.getAppRedirectUrl({
				environment: self.environment,
				path: 'login',
				asCompany: true,
				register: true,
				email: formSchema['emailAddress'],
				token: self.leadToken,
				silentLogin: true
			});
			// window.location.href = `https://app.mayple.com/login?asCompany=1&register=1&email=${formSchema['emailAddress']}&hideTerms=1`
			setTimeout(() => {
				window.location.href = redirectionURL;
			}, 1000);
		} else {
			console.error('Form submit failed w: ', formSchema);
			self.showErrorMessage();
			self.toggleSubmitButtonVisibility();
		}
	},

	setDependencies: function(container) {
		const self = this;

		let dependencies = validationRules[container]['dependencies'];

		if (dependencies.length > 0) {
			dependencies.forEach(function(dependency, index, list) {
				jQuery.ajax({
					url: dependency,
					cache: true
				}).done(function() {
					if (index === list.length - 1) {
						self.revealNextContainer();
					}
				});
			});

			let inputs = validationRules[container]['inputs'];
			for (let input in inputs) {
			 	inputs[input].set();
			}
		} else {
			self.revealNextContainer();
		}
	},

	revealNextContainer: function() {
		$('.welcome-step').addClass('hidden');
		// $('.welcome-step.active').removeClass('hidden');
	},

	checkErrors: function(container) {
		const self = this;

		// Remove previous error states
		//
		$('.error-message').addClass('hidden');

		let isClean = true;
		if (container === 'meetingContainer') {
			isClean = true;

			return true;
		}

		let fields = $('.welcome-step.active input').filter('[required]');

		fields.each(function(item) {
			$(this).removeClass('empty-field');

			let field = $(this).attr('name');
			let isValid = validationRules[container]['inputs'][field].validate($(this).val());

			if (!isValid || isValid == null) {
				console.warn( 'Not valid: ', field );
				$(this).addClass('empty-field');

				$('.brief-error div').text(validationRules[container]['inputs'][field].errorLog);
				$('.error-message').removeClass('hidden');
				isClean = false;

				return false;
			} else {
				if (container === 'briefForm' && !self.validEmail) {
					isClean = false;

					return false;
				};

				formSchema[field] = $(this).val();

				if (field === 'phoneNumber') {
					formSchema[field] = isValid;
				}
			}
		});

		// if (!$('#tos-checkbox').is(":checked")) {
		// 	if (container !== 'noForm') {
		// 		isClean = false;

		// 		$('.brief-error div').text('Terms of services must be agreed to start the health-check.');

		// 		return false;
		// 	} else {
		// 		isClean = true;
		// 	}

		// 	return isClean;
		// }

		return isClean;
	},

	validateEmailAddress: function() {
		const self = this;
		$('input[name="emailAddress"]').on( "focusout", function() {
			if ($(this).val().length < 5) { return; }
			let animationBox = $(this).closest('.welcome-v5-input-wrapper').children('.checking-animation');
			animationBox.addClass('anim-true');
			self.websiteSDK.isValidEmailDomain($(this).val())
					.then((value) => {
						self.validEmail = value;
						animationBox.addClass('load-complete');
						console.log('Valid domain resp: ', value);
						if (!value) {
							animationBox.addClass('validate-error'); }
						animationBox.children('.checkmark').addClass('draw');
					});
		});
		$('input[name="emailAddress"]').on("keyup", function() {
			let animationBox = $(this).closest('.welcome-v5-input-wrapper').children('.checking-animation');
			animationBox.removeClass('anim-true load-complete validate-error');
			animationBox.children('.checkmark').removeClass('draw');
		});
	},

	submitForm: async function() {
		const self = this;

		formSchema['frontendSalesQualificationScore'] = self.websiteSDK.calcSalesQualificationLeadScore(formSchema);

		$('.next-step-button p').text('Submitting...');
		$('.next-step-button').addClass('submitting');

		let hsFormSubmitFailed = false;
		let cPanelFormSubmitFailed = false;

		const identifyTraits = {
			firstName: formSchema.firstName,
			lastName: formSchema.lastName,
			emailAddress: formSchema.emailAddress
		};

		window.va.identify(identifyTraits);

		self.hasSubmittedForm = true;

		// Try/catch block of
		// Project Lead Creation
		//
		try {
			const result = await self.websiteSDK.createProjectLeadWithToken(formSchema);
			self.leadToken = result;

			console.log('Lead creation r: ', result);

			self.leadToken.length < 1 ? cPanelFormSubmitFailed = true : cPanelFormSubmitFailed = false;
		} catch (error) {
			cPanelFormSubmitFailed = true;

			console.error(error);

			self.showErrorMessage();
			self.toggleSubmitButtonVisibility();

			throw new Error("error on Project Lead Creation", { cause: error });
		}

		// Try/catch block of
		// HS lead creation
		//
		try {
			const result = await self.websiteSDK.submitHubspotForm(formSchema);
			console.log('HS r: ', result);

			result.status === 'error' ? hsFormSubmitFailed = true : hsFormSubmitFailed = false;
		} catch (error) {
			hsFormSubmitFailed = true;

			console.error(error);

			self.showErrorMessage();
			self.toggleSubmitButtonVisibility();

			throw new Error("error on HS Creation", { cause: error });
		}

		console.log(formSchema);

		if (!hsFormSubmitFailed && !cPanelFormSubmitFailed) {
			ttq.track('CompletePayment');

			self.websiteSDK.reportEvent('Wizard.Brief Finished', { category: 'Wizard.Brief', action: 'Finished' });
			self.websiteSDK.reportEvent('Lead Created', { category: 'Lead', action: 'Created' });

			const redirectionURL = self.websiteSDK.getAppRedirectUrl({
				environment: self.environment,
				path: 'login',
				asCompany: true,
				register: true,
				email: formSchema['emailAddress'],
				token: self.leadToken,
				silentLogin: true
			});

			console.log('Redirection URL: ', redirectionURL);
			// window.location.href = `https://app.mayple.com/login?asCompany=1&register=1&email=${formSchema['emailAddress']}&hideTerms=1`
			setTimeout(() => {
				window.location.href = redirectionURL;
			}, 1000);
		} else {
			console.error('Form submit failed w: ', formSchema);
			self.showErrorMessage();
			$('.next-step-button p').text('Submit');
			$('.next-step-button').removeClass('submitting');
		}
	},

	toggleSubmitButtonVisibility: function() {
		$('.brief-next-button.submittable').removeClass('disabled').addClass('submittable');
	},

	showErrorMessage: function() {
		$('.w-form-fail').css('display', 'block');
		$('.brief-error div').text('Something went wrong with the form submission. Please check that all required fields are filled out correctly and try again. If the problem persists, please contact our customer support for assistance.');
		$('.error-message').removeClass('hidden');
	},

	validatePhone: function(val) {
		const self = this;

		let iti = self.intlTel;
		if (iti.isValidNumber()) {
			return iti.getNumber(intlTelInputUtils.numberFormat.E164); }
		else { return false; }
	},

	sendAbandonEvent: function() {
		const self = this;
		if (self.hasSentAbandonEvent) {
			return; }

		self.hasSentAbandonEvent = true;
	  
		var fsSessionId = FS.getCurrentSession();
		var fsSessionURL = FS.getCurrentSessionURL();

		var beData = {
			fsSessionId: fsSessionId,
			fsSessionURL: fsSessionURL,
			firstName: formSchema.firstName,
			emailAddress: formSchema.emailAddress,
			environment: self.environment,
			abandonedStepIndex: self.currentStep,
			completedBrief: self.hasSubmittedForm,
			landingPage: 'Welcome v5'
		};
	  
		var beStringified = JSON.stringify(beData);
		
		var endpoint = 'https://lp.mayple.com/api/brief';
		
		if (navigator.sendBeacon) {
			var blob = new Blob([beStringified], { type: 'application/json' });
			navigator.sendBeacon(endpoint, blob);
		} else {
			// Fallback for browsers that don't support sendBeacon
			var xhr = new XMLHttpRequest();
			xhr.open('POST', endpoint, false);
			xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
			xhr.send(beStringified);
		}
		

		if (window.FS && typeof window.FS.event === 'function') {
			FS.event('Wizard.Brief.Step Abandoned', {
				stepName: document.querySelector('.welcome-step.active form').getAttribute('data-name'),
				abandonedStepIndex: self.currentStep
			});
		}
	},

	initIntlTel: function() {
		const self = this;
		let phoneInput = document.getElementById("phoneNumber");
		self.intlTel = window.intlTelInput(phoneInput, {
			initialCountry: "auto",
			utilsScript: "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.15/js/utils.js",
			geoIpLookup: function(success, failure) {
				$.get("https://ipinfo.io?token=1fa95a0e3e5a98", function() {}, "jsonp").always(function(resp) {
					success((resp && resp.country) ? resp.country : "");
					console.log('IP Resp: ', resp.country);
					self.ipLocation = resp.country;
					if (self.ipLocation === undefined) {
						self.ipLocation = ''; }
					console.log('Loc: ', self.ipLocation);
					self.fromTierICountry = self.tierICountries.includes( self.ipLocation?.toUpperCase() );
					self.checkTrafficSource('ip');
				});
			},
		});
	},

	fillCompanyName: function() {
		let value = $('#website').val();

		if (value.length > 5) {
			let companyName = '';
			// construct the value as a URL
			let hostname = new URL(value).hostname;
			// if we have the www. at the start; trim it e.g. www.website-name.com.au => website-name.com.au
			if (hostname.startsWith('www.')) {
				hostname = hostname.replace('www.', '');
			}
			// turn the value into an array splitted by dots e.g. website-name.com.au => [website-name], [com], [au]
			let valueSplit = hostname.split(".");
			// Get the first of the array which is [website-name]
			companyName = valueSplit[0];
			$('#company').val(companyName);
		}
	},

	prefillWebsite: function() {
		if (Cookies.get('_mayple-websiteAddress') && Cookies.get('_mayple-websiteAddress').length > 0) {
			let mailAddress = Cookies.get('_mayple-websiteAddress');
			$('#website').val(mailAddress);

			briefHench.fillCompanyName();
		}
	},

	prefillFields: function() {
		if (Cookies.get('_mayple-prefilled-fields') && Cookies.get('_mayple-prefilled-fields')?.length > 0) {
			let prefillData = JSON.parse(Cookies.get('_mayple-prefilled-fields'));
			Object.keys(prefillData).forEach((field) => {
				formSchema[field] = prefillData[field];
				console.log('Field: ', field, prefillData[field]);
				document.querySelector(`input[name=${field}]`).value = prefillData[field];
			});
		}

		var urlSearchParams = new URLSearchParams(window.location.search);
		var params = Object.fromEntries(urlSearchParams.entries());

		if (params['invitee_full_name'] && params['invitee_full_name'].length > 0) {
			$('#firstName').val(params['invitee_full_name']);
		}

		if (params['invitee_email'] && params['invitee_email'].length > 0) {
			$('#emailAddress').val(params['invitee_email']);
		}

		if (params['answer_1'] && params['answer_1'].length > 0) {
			$('#website').val(params['answer_1']);
		}
	},

	vaRegisterEvents: function() {
		window.va.identify({ externalCustomerId: formSchema['externalCustomerId'] });
	},

	fireLeftOverEvents: function() {
		const self = this;

		let event = sessionStorage.getItem('eventToFire');

		if (event) {
			event = JSON.parse(event);
			event.traits = JSON.parse(event.traits);

			self.websiteSDK.reportEvent(event.name, event.traits)

			if (event.name === 'Website.Call Scheduled') {
				self.websiteSDK.reportEvent('Lead Created', { category: 'Lead', action: 'Created' });

				if (Cookies.get('_mayple-prefilled-fields') && Cookies.get('_mayple-prefilled-fields')?.length > 0) {
					let prefillData = JSON.parse(Cookies.get('_mayple-prefilled-fields'));

					const identifyTraits = {
						firstName: prefillData.firstName,
						lastName: prefillData.lastName,
						email: prefillData.emailAddress
					};

					window.va.identify(identifyTraits);
				}
			}
		}
	},

	listenEnvChoice: function() {
		const self = this;

		var urlSearchParams = new URLSearchParams(window.location.search);
		var params = Object.fromEntries(urlSearchParams.entries());

		if (params['force_env'] && params['force_env'].length > 0) {
			if (params['force_env'] !== 'storky' && params['force_env'] !== 'torky') {
				return;
			}
			
			self.environment = params['force_env'];

			console.log('Force Env: ', self.environment);
		}

		if (params['debug'] && params['debug'].length > 0) {
			self.debugMode = true;
		}
	},

	restructureBudget: function() {
		var rawValue = $('#marketingbudget').val().replace(/\D/g, "");
		if (parseInt(rawValue) > 1000000) {
			rawValue = '1000000';
		}
		var withComma = rawValue.split(/(?=(?:\d{3})+$)/).join(",");
		$('#marketingbudget').val(withComma);

		rawValue = parseInt(rawValue);
		formSchema.estimatedMediaBudget = rawValue;
	},
}


$(document).ready(function(e) {
	briefHench.checkTrafficSource('dom');

	briefHench.loadSDK('https://static.cdn.mayple.com/website/js/website-sdk/website-sdk.js', function() {
		briefHench.listenEnvChoice();
        briefHench.insertSDK();
		
		briefHench.vaRegisterEvents();
    });
	briefHench.handleStepChange();
	briefHench.initIntlTel();
	briefHench.prefillFields();
	briefHench.prefillWebsite();

	briefHench.validateEmailAddress();


	setTimeout(function() {
		// briefHench.vaRegisterEvents();

		briefHench.websiteSDK.reportEvent('Wizard.Brief Started', { category: 'Wizard.Brief', action: 'Started', isTierI: briefHench.fromTierICountry });

		briefHench.fireLeftOverEvents();
	}, 3000);
});

$('#website').keyup(function(e) {
	if (e.originalEvent.keyCode == 32) {
		$(this).val( $(this).val().slice(0, -1) ) }

	// If user didn't write down the protocal name...
	if ($(this).val().length > 5 && !$(this).val().startsWith('http')) {
		// add it programatically as the URL object is not validating the string without the https:// prefix
		$(this).val('https://' + $(this).val());
	} else if ($(this).val().startsWith('http://')) {
		// turn http to https
		$(this).val($(this).val().replace('http://', 'https://'));
	}

	if ($('.brief-next-button').hasClass('disabled')) {
		$('.brief-error').css('display', 'none');
		$('.welcome-step.active .brief-next-button').removeClass('disabled');
	}
});

$('#website').focusout(function(e) {
	briefHench.fillCompanyName();
});

$('input').keyup(function() {
	if ($('.brief-next-button').hasClass('disabled')) {
		$('.brief-error').css('display', 'none');
		$('.welcome-step.active .brief-next-button').removeClass('disabled');
	}

	if ($(this).val().length < 1) {
		$('.welcome-step.active .brief-next-button').addClass('disabled')
	}
});

$(document).on('keypress',function(e) {
	if (e.keyCode === 13 && briefHench.currentStep != 0) {
		briefHench.toNextStep();
	}
});

$('#tos-checkbox').change(function() {
	if ($('#tos-checkbox').is(':checked')) {
		$('.brief-next-button').removeClass('disabled');
	} else {
		$('.brief-next-button').addClass('disabled');
	}
});

// $('#sms-checkbox').change(function() {
// 	if ($('#sms-checkbox').is(':checked')) {
// 		$('#sms-input').val(formSchema['phoneNumber']);
// 		$('#sms-input').removeClass('hidden');
// 	} else {
// 		$('#sms-input').addClass('hidden');
// 		$('#sms-input').val('');
// 	}
// });


window.addEventListener("message", function(event) {
	if (!event.origin === 'https://meetings.hubspot.com') { return; }
	if (event.data.meetingBookSucceeded) {
		let responseDetails = event.data.meetingsPayload.bookingResponse?.postResponse?.contact;
		formSchema.firstName = responseDetails.firstName;
		formSchema.lastName = responseDetails.lastName;
		formSchema.emailAddress = responseDetails.email;

		let hsFormSubmitFailed = false;
		async function hsSubmit() {
			// Try/catch block of
			// HS lead creation
			//
			try {
				const result = await self.websiteSDK.submitHubspotForm(formSchema); 
				console.log('HS r: ', result);

				result.status === 'error' ? hsFormSubmitFailed = true : hsFormSubmitFailed = false;
			} catch (error) {
				hsFormSubmitFailed = true;

				console.error(error);

				self.showErrorMessage();
				self.toggleSubmitButtonVisibility();

				throw new Error("error on HS contact update through meeting", { cause: error });
			}
		}

		hsSubmit();

		const identifyTraits = {
			firstName: formSchema.firstName,
			lastName: formSchema.lastName,
			emailAddress: formSchema.emailAddress
		};

		window.va.identify(identifyTraits);


		// formSchema.websiteAddress = responseDetails.websiteAddress?.length > 2 ? responseDetails.websiteAddress : briefHench.prefillWebsite();

		$('.skip-meeting-link-block').addClass('hidden');

		briefHench.createLead();


		briefHench.websiteSDK.reportEvent('Wizard.Brief Finished', { category: 'Wizard.Brief', action: 'Finished'});
		briefHench.websiteSDK.reportEvent('Wizard.Brief.Call Scheduled', {
			maypleUniversalTrackingId: window.mayple_analytics._userId,
			frontendSalesQualificationScore: formSchema.frontendSalesQualificationScore}
		);

	// 	window.location.href = 'https://app.mayple.com/login?register=1';
	// 	//window.location.href = 'https://mayple.com/thank-you?name=' + briefHench.formSchema['firstName'];
	}
});

window.addEventListener('beforeunload', function(event) {
    briefHench.sendAbandonEvent();
});

document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
      briefHench.sendAbandonEvent();
    }
});